import { api as axiosApi } from '../../utils/axios';
import { Response } from '../../models/response';
import SnackbarUtils from '../../utils/SnackbarUtils';
import i18n from 'i18next';
import {
    PartnerRegistrationRequest,
    RegistrationRequest,
} from '../../models/Authentication/Registration';
import { isNullOrUndefined } from '../../utils/utils';

const useRegistration = () => {
    const REGISTER_URL = '/api/v1/register';
    const PARTNER_REGISTER_URL = 'api/v1/partner-registration';

    const handleErrorRequest = (error) => {
        if (error.data && error.data.errors) {
            if (Array.isArray(error.data.errors)) {
                // handle Shopify or BC error
                SnackbarUtils.error(error.data.errors[0]);
            } else {
                // handle registration error, check for translate
                const errorKey = Object.keys(error.data.errors)[0];
                const firstError = error.data.errors[errorKey][0];
                const errorKeyString =
                    'ERROR.REGISTRATION_ERRORS.' +
                    errorKey.toUpperCase() +
                    '.' +
                    firstError.toUpperCase();

                SnackbarUtils.error(
                    i18n.exists(errorKeyString, {
                        ns: 'errors',
                    })
                        ? i18n.t(errorKeyString, { ns: 'errors' })
                        : !isNullOrUndefined(error.data.message)
                        ? error.data.message
                        : i18n.t('ERROR.GLOBAL_ERROR', { ns: 'errors' })
                );
            }
        }
    };

    const makeRequestBody = (data): RegistrationRequest => {
        return {
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            phone: data.phone,
            company: data.company,
            tax_number: data.tax_number,
            default_stock: data.default_stock,
            country: data.country,
            postcode: data.postcode,
            city: data.city,
            address1: data.address1,
            address2: data.address2,
            password: data.password,
            password_confirmation: data.password_confirmation,
            terms_of_service: Number(data.terms_of_service),
            has4322: Number(data.has4322),
            note: data.note,
        };
    };

    const makeRequestBodyPartner = (data): PartnerRegistrationRequest => {
        return {
            email: data.email,
            phone: data.phone,
            company: data.company,
            store: data.store,
            privacy_notice: Number(data.privacy_notice),
            note: data.note,
        };
    };
    const sendRegistration = (data) => {
        return axiosApi
            .post<RegistrationRequest>(REGISTER_URL, makeRequestBody(data))
            .then((resp: any) => {
                return Response.createSuccessful<RegistrationRequest>(
                    resp.data,
                    resp.status
                );
            })
            .catch((error: { data: any; status: number }) => {
                handleErrorRequest(error);

                throw error;
            });
    };

    const sendPartnerRegistration = (data) => {
        return axiosApi
            .post<PartnerRegistrationRequest>(
                PARTNER_REGISTER_URL,
                makeRequestBodyPartner(data)
            )
            .then((resp: any) => {
                return Response.createSuccessful<PartnerRegistrationRequest>(
                    resp.data,
                    resp.status
                );
            })
            .catch((error: { data: any; status: number }) => {
                handleErrorRequest(error);

                throw error;
            });
    };

    return {
        sendRegistration,
        sendPartnerRegistration,
    };
};

export default useRegistration;
